import { render, staticRenderFns } from "./fbocrbutton.vue?vue&type=template&id=2aa69f52&scoped=true&"
import script from "./fbocrbutton.vue?vue&type=script&lang=js&"
export * from "./fbocrbutton.vue?vue&type=script&lang=js&"
import style0 from "./fbocrbutton.vue?vue&type=style&index=0&lang=css&"
import style1 from "./fbocrbutton.vue?vue&type=style&index=1&id=2aa69f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa69f52",
  null
  
)

export default component.exports